import { render, staticRenderFns } from "./IdleDialog.vue?vue&type=template&id=6b9aea18&scoped=true"
import script from "./IdleDialog.vue?vue&type=script&lang=js"
export * from "./IdleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9aea18",
  null
  
)

export default component.exports